export default function(cents) {
  return parseFloat(cents)
    .toFixed(2)
    .replace(".", ",");
}
